import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import VehicleTypeTable from "components/vehicleCategory/VehicleTypeTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import Somethingwentwrong from "pages/Somethingwentwrong";

import VehicleTypeServices from "services/VehicleTypeServices";
import { FiPlus } from "react-icons/fi";
import VehicleTypeDrawer from "components/drawer/VehicleTypeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";
import { FiRefreshCcw } from "react-icons/fi";

const VehicleType = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const [status, setStatus] = useState("");
  const { title, serviceId } = useToggleDrawer();
  const { data, loading, error } = useAsync(
    VehicleTypeServices.getAllVehicleType
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle model" && perm.view === 1
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle model" && perm.delete === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle model" && perm.edit === 1
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle model" && perm.add === 1
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle model" && perm.export === 1
      );

  const {
    vehicleTypeRef,
    dataTable,
    serviceData,
    handleSubmitVehicleType,
    currentPage,
  } = useFilter(Array.isArray(data.data) ? data.data : [], itemsPerPage);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const updatedData = data?.data?.map((item, index) => {
    // console.log(item);
    return {
      "SI.No": index + 1,
      "Vehicle Type": item.name,
    };
  });

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <VehicleTypeDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={vehicleTypeRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    placeholder="Quick Search"
                    autoComplete="off"
                    onChange={handleSubmitVehicleType}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Vehicle Type
                  </Button>
                )}

                {hideExport && (
                  <div className="items-center">
                    <ExportDataXlsx
                      exportDataXlsx={updatedData}
                      fileNames="Vehicle Types"
                    />
                  </div>
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize text-center sticky top-0 z-10">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>Actions</TableCell>
                      </tr>
                    </TableHeader>
                    <VehicleTypeTable
                      vehicleCategory={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Vehicle Model." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default VehicleType;
